import type { Dictionary } from '../i18n/dictionary';
import type { Story } from '../lib/story';
import { LinkCard, LinkCardGrid } from './LinkCard';

const sample: Dictionary<{ cards: { title: string; text: string }[] }> = {
  pl: {
    cards: [
      {
        title: 'Zmiana kodów',
        text: 'Podmienia kody kwalifikacji według listy par stary → nowy.',
      },
      {
        title: 'Łączenie kwalifikacji',
        text: 'Scala dwie kwalifikacje w jedną, zachowując przypisania.',
      },
    ],
  },
  en: {
    cards: [
      {
        title: 'Changing codes',
        text: 'Replaces qualification codes from a list of old → new pairs.',
      },
      {
        title: 'Merging qualifications',
        text: 'Merges two qualifications into one, keeping assignments.',
      },
    ],
  },
};

export default {
  kind: 'component',
  title: { pl: 'Karta z linkiem', en: 'Link card' },
  description: {
    pl: 'Tytuł nad krótkim tekstem, cała karta jest jednym linkiem — dla strony-indeksu, na której wpis trzeba opisać zdaniem, żeby wybrać go bez otwierania. `LinkCardGrid`: jedna kolumna na telefonie, dwie od md.',
    en: 'A title over a short text, the whole card one link — for an index page whose entries need a sentence each to be picked without opening them. `LinkCardGrid`: one column on a phone, two from md.',
  },
  variants: [
    {
      name: { pl: 'Siatka', en: 'Grid' },
      render: (locale) => (
        <LinkCardGrid>
          {sample[locale].cards.map((card) => (
            <LinkCard
              key={card.title}
              to="/library/link-card"
              title={card.title}
            >
              {card.text}
            </LinkCard>
          ))}
        </LinkCardGrid>
      ),
    },
  ],
} satisfies Story;
